import React, { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Modal,
  Backdrop,
  Fade,
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NearBy from '../../../assets/nearBy.png';
import ShareStory from '../../../assets/sharestory.png';
import chatVedio from '../../../assets/vedio/chatVedio.mp4';
import marketPlace from '../../../assets/marketPlace.png';
import Promotiontool from '../../../assets/promotation.png';
import Audition from '../../../assets/audition.png';
import UserProfile from '../../../assets/userProfile.png';
import Notification from '../../../assets/Notification.png';
import Photo from '../../../assets/Photo.png';
import IndusrtyReview from '../../../assets/industryReview.png';
import chat from '../../../assets/Chat.png';

// New high-quality generated feature images
import f1 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 04_48_07 PM.png';
import f2 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 04_49_21 PM.png';
import f3 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 04_54_26 PM.png';
import f4 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 04_56_14 PM.png';
import f5 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 04_58_19 PM.png';
import f6 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 05_03_55 PM.png';
import f7 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 05_05_49 PM.png';
import f8 from '../../../assets/features/ChatGPT Image Aug 24, 2026, 05_07_20 PM.png';

import { motion } from 'framer-motion';
import { useTheme } from '../../../ThemeContext';

const cardColors = [
  { pillBg: 'rgba(99,102,241,0.15)', pillText: '#6366f1', buttonHover: '#6366f1' }, // 01 purple
  { pillBg: 'rgba(244,63,94,0.15)', pillText: '#f43f5e', buttonHover: '#f43f5e' }, // 02 red
  { pillBg: 'rgba(59,130,246,0.15)', pillText: '#3b82f6', buttonHover: '#3b82f6' }, // 03 blue
  { pillBg: 'rgba(16,185,129,0.15)', pillText: '#10b981', buttonHover: '#10b981' }, // 04 green
  { pillBg: 'rgba(249,115,22,0.15)', pillText: '#f97316', buttonHover: '#f97316' }, // 05 orange
  { pillBg: 'rgba(139,92,246,0.15)', pillText: '#8b5cf6', buttonHover: '#8b5cf6' }, // 06 purple
  { pillBg: 'rgba(20,184,166,0.15)', pillText: '#14b8a6', buttonHover: '#14b8a6' }, // 07 teal
  { pillBg: 'rgba(239,68,68,0.15)', pillText: '#ef4444', buttonHover: '#ef4444' }, // 08 red
  { pillBg: 'rgba(59,130,246,0.15)', pillText: '#3b82f6', buttonHover: '#3b82f6' }, // 09 blue
  { pillBg: 'rgba(168,85,247,0.15)', pillText: '#a855f7', buttonHover: '#a855f7' }, // 10 purple
  { pillBg: 'rgba(236,72,153,0.15)', pillText: '#ec4899', buttonHover: '#ec4899' }, // 11 pink
  { pillBg: 'rgba(234,179,8,0.15)', pillText: '#eab308', buttonHover: '#eab308' }, // 12 yellow
];
const features = [

  {
    title: 'Shooting Location',
    description: 'Browse and post available shooting locations for film and media productions, connecting creators with the perfect spaces for their projects.',
    fullDetails: 'FilmHook Media’s Shooting Location feature is a hub where creators can discover and share locations suitable for filming. Users can post their spaces, whether homes, scenic spots, or unique venues, making them accessible to production teams. Filmmakers, photographers, and media professionals can browse available locations, ensuring efficient planning and site selection. By facilitating connections between location owners and industry experts, FilmHook Media supports seamless production logistics. This feature optimizes the search for shooting spots, helping users find the ideal setting for their creative projects.',
    image: f1,
  },
  {
    title: 'Live Option',
    description: 'Engage audiences instantly with live video streaming, real-time chats, and interactive features for creators, influencers, and professionals.',
    fullDetails: 'FilmHook Media’s Live Option allows users to broadcast real-time video content, enabling direct engagement with audiences through interactive chat and reactions. Whether hosting industry discussions, showcasing creative work, or connecting with followers, this feature enhances instant interaction and visibility. Users can go live with high-quality streaming, interact through live comments, and receive engagement via likes and reactions. This feature is ideal for industry professionals, influencers, and creators looking to share content in the moment. With secure streaming, audience participation, and professional hosting tools, FilmHook Media’s Live Option is a powerful way to build community, share insights, and create immersive experiences in entertainment and media.',
    image: f2,
  },
  {
    title: 'Chat & Seamless Calls',
    description: 'Connect with ease using FilmHook Mediaapp chat, audio, and video call options for seamless real-time conversations and collaborations.',
    fullDetails: 'FilmHook Media’s Chat & Calls feature is built for smooth, secure, and real-time communication—tailored to both public users and industry professionals. Whether youre collaborating on a film project or simply staying in touch with your team, this tool makes interaction simple and effective.💬 Messaging->Instant text messaging with media sharing (images, videos, files up to 2GB). mart status indicators: typing alerts and read receipts. End-to-end encryption ensures your conversations stay private. 🎧 Audio & Video Calls-> High-quality voice and video calls for one-on-one or group conversations. Optimized for stability, even on low-bandwidth networks. Face-to-face interaction to enhance creative discussions. 🏷️ Custom Labels-> Organize chats with tags like “Casting”, “Marketing”, or “Production” for quick access and clarity. 📅 In-Chat Event Scheduling Schedule meetings, auditions, or shoot dates right from the chat. Integrated calendar support with automated reminders. 📺 Live Broadcasting-> Host live events like on-set showcases, auditions, or Q&A sessions. Audience engagement with real-time polling and voting features.',
    image: f3,
    video: chatVedio,
  },
  {
    title: 'Create and Share Your Story',
    description: 'Share creative moments through engaging photo and video stories with Film-hook Mediaapp’s interactive feature.',
    fullDetails: 'FilmHook Media’s Story feature lets users share fleeting moments, behind-the-scenes content, and quick updates through photos and short videos. Similar to popular story formats, these posts are visible for a limited time, creating a sense of urgency and exclusivity. Creators can use this tool to tease upcoming projects, share day-to-day activities, or highlight special events. Stories foster a more personal connection between professionals and their audience, enhancing engagement and keeping followers informed in a dynamic and visually appealing way.',
    image: f4,
  },
  {
    title: 'Discover Professionals Nearby',
    description: 'Discover professionals near you based on username, occupation, and shared posts, fostering instant connections and meaningful collaborations.',
    fullDetails: 'FilmHook Media’s Near to Me feature bridges the gap between industry professionals by helping users discover creators, collaborators, and influencers in their vicinity. Based on username, occupation, and uploaded posts, it enables tailored networking opportunities. Users can browse profiles, interact with professionals, and build strong creative partnerships through localized connections. Whether searching for potential teammates, industry colleagues, or creative minds in your area, this feature makes connecting convenient and impactful. FilmHook Media creates an environment where users can find the right talent and collaboration opportunities easily, boosting engagement and professional growth',
    image: NearBy,
  },
  {
    title: 'Market Place',
    description: 'Buy, sell, and trade products within a thriving creative community, making business interactions seamless and efficient',
    fullDetails: 'FilmHook Media’s Marketplace enables users to buy, sell, and promote their products within a specialized creative network. Whether selling equipment, services, or media-related goods, this feature makes business interactions effortless. Users can browse listings, engage with sellers, and make direct transactions within a trusted industry-focused space. Designed for creators, professionals, and entrepreneurs, FilmHook Media’s Marketplace ensures easy accessibility to valuable products and services. With secure transactions and a broad audience, the Marketplace fosters business growth and helps users monetize their creative contributions efficiently.',
    image: marketPlace,
  },
  {
    title: 'Promotion Tools',
    description: 'Promote your brand, content, or business by uploading eye-catching promotional images to enhance exposure and engagement.',
    fullDetails: 'FilmHook Media’s Promotion feature allows businesses, influencers, and creators to share promotional content through visually compelling images. Designed for marketing, branding, and showcasing work, it helps users gain traction with their audience and expand reach. Whether launching a new project, highlighting services, or increasing brand awareness, this feature ensures maximum visibility. By sharing promotional images, users can engage with a broader community, attract potential clients, and establish their presence in the creative industry. FilmHook Media empowers users to take control of their promotions with strategic and impactful image-based advertising.',
    image: Promotiontool,
  },
  {
    title: 'Audition',
    description: 'Exclusive audition feature allows industry professionals to post opportunities while maintaining privacy and professionalism.',
    fullDetails: 'Designed for media professionals, Film-hook Media’s Audition feature provides a dedicated space for casting calls, talent searches, and industry-exclusive auditions. Only verified industry members can post audition notices, ensuring professionalism and discretion. This feature allows casting directors, producers, and creators to connect with talent efficiently. By limiting access to industry professionals, it maintains a high standard of privacy and credibility. FilmHook Media simplifies talent recruitment, ensuring auditions remain exclusive and meaningful within the entertainment and media industries.',
    image: Audition,
  },
  {
    title: 'User Profile',
    description: 'Showcase your biography, personal details, body measurements, education, and activity history in a comprehensive digital portfolio.',
    fullDetails: 'FilmHook Media’s User Profile feature offers a detailed space for users to highlight their personal and professional information. It includes a biography section to introduce yourself, personal details like body measurements, education history, and an activity tracker to monitor interactions and engagements. This feature allows professionals to present their credentials, achievements, and personal insights in a structured format. Whether showcasing work experience, connecting with industry peers, or maintaining a professional online presence, the User Profile ensures visibility and credibility. Tailored for creators, artists, and professionals, it helps users manage their industry identity effectively while providing space for personal updates and career growth.',
    image: UserProfile,
  },
  {
    title: 'Notification',
    description: 'Never miss interactions with real-time notifications for messages, comments, likes, shares, and important updates.',
    fullDetails: 'The Notification feature in FilmHook Media ensures users stay informed about activities related to their profile, posts, and interactions. From new messages and likes to comments and shares, users receive instant alerts, keeping engagement seamless. Whether tracking industry updates, responding to comments, or receiving project-related notifications, this feature enhances user experience by keeping them informed. With a streamlined notification system, professionals and creators can efficiently manage their connections, ensuring they never miss out on important updates.',
    image: Notification,
  },
  {
    title: 'Post (Likes, Comments, Shares)',
    description: 'Boost your content’s visibility with likes, comments, and shares, fostering meaningful interactions and audience growth.',
    fullDetails: 'Posts on FilmHook Media allow users to engage with audiences through likes, comments, and shares, enhancing content reach and interaction. This feature helps professionals, creators, and influencers connect with their audience by encouraging meaningful discussions and engagement. With comment sections, users can exchange thoughts, feedback, and collaborations. Likes help highlight popular content, while shares expand post visibility across networks, ensuring greater exposure. Whether showcasing new projects, sharing industry insights, or posting creative work, FilmHook Media’s Post Engagement feature enables an interactive and dynamic content-sharing experience.',
    image: Photo,
  },
  {
    title: 'Verified Industry Reviews',
    description: 'Industry professionals receive credibility-building reviews based on completed projects, ensuring trust and recognition in their field.',
    fullDetails: 'FilmHook Media’s Industry Review feature is exclusive to professionals, providing verified reviews based on completed projects. It allows industry experts to showcase their work credibility, gaining trust and recognition within the community. Unlike standard user engagement, this review system ensures that only professionals with project experience receive ratings, maintaining authenticity and industry standards. Designed for professionals in entertainment, filmmaking, and media, this feature offers an added layer of trust, helping users build their reputation and secure future opportunities.',
    image: IndusrtyReview,
    vedio: ""
  },

];

const FeaturesGridSection = () => {
  const { isDarkMode } = useTheme();
  const [openIndex, setOpenIndex] = useState(null);

  const handleOpen = (index) => setOpenIndex(index);
  const handleClose = () => setOpenIndex(null);

  return (
    <Box
      sx={{
        py: 8,
        px: { xs: 2, md: 4 },
        backgroundColor: isDarkMode ? '#050a14' : '#fafafa',
        position: 'relative',
        filter: openIndex !== null ? 'blur(4px)' : 'none',
        transition: 'filter 0.3s',
      }}
    >
      <Box sx={{ maxWidth: '1350px', mx: 'auto' }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, px: 2, py: 0.5, borderRadius: '20px', background: isDarkMode ? 'rgba(255,255,255,0.05)' : '#eef2ff', mb: 2 }}>
            <AutoAwesomeIcon sx={{ color: '#6366f1', fontSize: '1rem' }} />
            <Typography sx={{ color: isDarkMode ? '#fff' : '#4f46e5', fontSize: '0.85rem', fontWeight: 600 }}>
              Platform Features
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} sx={{ color: isDarkMode ? '#fff' : '#0f172a', mb: 2, fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
            Powerful Features for <Box component="span" sx={{ background: 'linear-gradient(90deg, #6366f1, #3b82f6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Everyone</Box>
          </Typography>
          <Typography sx={{ color: isDarkMode ? 'rgba(255,255,255,0.7)' : '#64748b', fontSize: '1.1rem', maxWidth: '600px', mx: 'auto' }}>
            Explore powerful tools and features designed for creators, professionals, and businesses.
          </Typography>
        </Box>

      <Box 
        sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, 
          gap: 3 
        }}
      >
        {features.map((feature, index) => {
          const colorObj = cardColors[index % cardColors.length];
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: index * 0.1, // Reduced delay for faster rendering
              }}
              style={{ height: '100%' }}
            >
              <Card
                sx={{
                  position: 'relative',
                  height: '100%',
                  minHeight: '380px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  backgroundColor: isDarkMode ? '#101726' : '#ffffff',
                  color: isDarkMode ? '#fff' : '#0f172a',
                  borderRadius: '24px',
                  border: isDarkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.02)',
                  boxShadow: isDarkMode ? 'none' : '0 12px 36px rgba(0,0,0,0.04)',
                  transition: 'all 0.3s ease-in-out',
                  overflow: 'visible',
                  '&:hover': {
                    borderColor: colorObj.buttonHover,
                    boxShadow: isDarkMode ? `0 12px 36px ${colorObj.pillBg}` : '0 20px 48px rgba(0,0,0,0.08)',
                    transform: 'translateY(-5px)',
                    '& .see-more-btn': {
                      color: colorObj.buttonHover,
                      borderColor: colorObj.buttonHover
                    }
                  }
                }}
              >
                {/* Number Pill */}
                <Box sx={{ position: 'absolute', top: 16, left: 16, background: colorObj.pillBg, color: colorObj.pillText, borderRadius: '12px', px: 1.5, py: 0.5, fontSize: '0.8rem', fontWeight: 800, zIndex: 10 }}>
                  {(index + 1).toString().padStart(2, '0')}
                </Box>
                
                <Box sx={{ pt: 5, pb: 1, px: 2, display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <CardMedia
                    component="img"
                    image={feature.image}
                    alt={feature.title}
                    sx={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '320px',
                      objectFit: 'contain',
                      filter: 'drop-shadow(0px 10px 20px rgba(0,0,0,0.15))',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.03)'
                      }
                    }}
                  />
                </Box>
                
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', px: 2, pb: '24px !important', width: '100%' }}>
                  <Typography variant="h6" fontWeight={800} sx={{ fontSize: '1.05rem', color: isDarkMode ? '#fff' : '#1e293b', mb: 1, lineHeight: 1.3 }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '0.75rem', color: isDarkMode ? 'rgba(255,255,255,0.6)' : '#64748b', mb: 3, lineHeight: 1.5, flexGrow: 1, px: 1 }}>
                    {feature.description}
                  </Typography>
                  
                  <Button 
                    className="see-more-btn"
                    variant="outlined" 
                    onClick={() => handleOpen(index)} 
                    endIcon={<ArrowForwardIcon sx={{ fontSize: '0.9rem' }} />}
                    sx={{
                      textTransform: 'none', 
                      padding: '4px 18px',
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      borderRadius: '30px',
                      border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid #e2e8f0',
                      color: isDarkMode ? 'rgba(255,255,255,0.7)' : '#64748b',
                      transition: 'all 0.3s ease',
                      width: 'max-content',
                      mx: 'auto'
                    }}
                  >
                    See More
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          );
        })}
      </Box>
    </Box>

      {/* Modal Section */}
      <Modal
        open={openIndex !== null}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 300,
        }}
      >
        <Fade in={openIndex !== null}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: isDarkMode ? '#101726' : 'background.paper',
              color: isDarkMode ? '#fff' : 'inherit',
              borderRadius: 2,
              boxShadow: 24,
              border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : 'none',
              p: 4,
              maxWidth: 1000,
              width: '90%',
            }}
          >
            {openIndex !== null && (
              <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={4}>
                {/* Video Section */}
                <video
                  src={features[openIndex].video}
                  controls
                  autoPlay
                  muted
                  style={{
                    width: '100%',
                    maxWidth: '450px',
                    borderRadius: '10px',
                    height: 'auto',
                    marginBottom: "50px",
                    display: features[openIndex].video ? 'block' : 'none'
                  }}
                />

                {/* Text Section */}
                <Box flex={1}>
                  <Typography variant="h5" fontWeight={600} gutterBottom sx={{ textAlign: "center", color: '#07a4f5' }}>
                    {features[openIndex].title}
                  </Typography>
                  <Typography variant="body1" sx={{ textAlign: "justify", paddingTop: "10px", color: isDarkMode ? 'rgba(255,255,255,0.8)' : 'text.secondary' }}>
                    {features[openIndex].fullDetails}
                  </Typography>

                  <Box mt={3} textAlign="right">
                    <Button onClick={handleClose} variant="contained" sx={{ backgroundColor: "#07a4f5", '&:hover': { backgroundColor: '#068bc2' } }}>
                      Close
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Fade>
      </Modal>

    </Box>
  );
};

export default FeaturesGridSection;
